
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import Table from './Table'
import SearchSelect from '~/components/Common/UI/Search/SearchSelect'
import api from '~/api/' // server

export default {
    name: 'OvertimeUnusual',
    components: {
        SearchSelect,
        Table,
    },
    data() {
        return {
            unusual: null,
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
    },
    watch: {
        getSearch() {
            this.getData()
        },
    },
    mounted() {
        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        this.getDataInit()
    },
    methods: {
        async getData() {
            // TODO: 초기데이터 없으면 강제로 20201104일로 잡아줌 (나중에 빼기 if 부분, getData params 받는 부분)

            const params = {
                menuType: 'MENU_STOCK_OU',
                ...this.getSearch,
            }
            this.unusual = (await api.getUnusual(params)).data
        },
        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        async getDataInit() {
            const params = {
                menuType: 'MENU_STOCK_OU',
                ...this.getSearch,
            }
            this.unusual = (await api.getUnusual(params)).data
            let count = 0
            while(this.unusual.items.length < 1){
                count++
                params.startDate = dayjs(new Date()).subtract(count, 'days').format('YYYYMMDD')
                this.unusual = (await api.getUnusual(params)).data
            }
              
            // 22.04.05 suye 정렬기준 변경 
            this.unusual.items.sort((a,b) => b.changeRate - a.changeRate)
        }, 
    },
}
